import { render, staticRenderFns } from "./AddEditRep.vue?vue&type=template&id=65040965&scoped=true&"
import script from "./AddEditRep.vue?vue&type=script&lang=js&"
export * from "./AddEditRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65040965",
  null
  
)

export default component.exports